export default "__VITE_ASSET__DSYhnZ6___"